import React from "react";
import { Construction } from "lucide-react";

function UnderDevelopment() {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-200px)] bg-gray-50">
      <div className="text-center px-4 py-8 max-w-md">
        <div className="flex justify-center mb-6">
          <div className="p-4 bg-yellow-100 rounded-full">
            <Construction className="w-12 h-12 text-yellow-600" />
          </div>
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-3">
          This module is currently under development.
        </h2>
        <p className="text-gray-600 text-lg">
          It will be available in an upcoming release.
        </p>
      </div>
    </div>
  );
}

export default UnderDevelopment;

